export default __webpack_public_path__ + "static/media/seattle.b96fee4f.png";